import React from 'react';
import classNames from 'classnames/bind';
import { Link, Text } from '@beef/ui-kit';
import { useIsMobileDimension } from "../../../../hooks/useGetDimensionGroup";
import { DeviceTag } from "../../../DeviceTag";
import { Reviews } from "./components/Reviews";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
export var Header = function Header(_ref) {
  var _promoBadges;
  var device = _ref.device,
    type = _ref.type;
  var isMobile = useIsMobileDimension();
  var promoBadges = [];
  if (device !== null && device !== void 0 && device.promoBadges) {
    promoBadges = Array.isArray(device.promoBadges) ? device.promoBadges : [device.promoBadges];
  }
  var promoBadgeSize = isMobile ? 'xs' : 'm';
  return /*#__PURE__*/React.createElement("div", {
    className: cx('header')
  }, device !== null && device !== void 0 && device.link ? /*#__PURE__*/React.createElement(Link, {
    href: device.link,
    isNoUnderline: true,
    size: "size2-m",
    target: "_blank",
    variant: "dark"
  }, device.name) : /*#__PURE__*/React.createElement(Text, {
    extraAttributes: {
      itemProp: 'name'
    },
    size: "size2-m",
    tagType: "h1"
  }, device.name), /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper')
  }, !!((_promoBadges = promoBadges) !== null && _promoBadges !== void 0 && _promoBadges.length) && /*#__PURE__*/React.createElement("div", {
    className: cx('content-wrapper')
  }, promoBadges.map(function (promoBadge) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('tag-wrapper'),
      key: promoBadge.children
    }, /*#__PURE__*/React.createElement(DeviceTag, {
      help: promoBadge.help,
      isTooltip: !!promoBadge.help,
      size: promoBadgeSize,
      textColor: promoBadge.textColor,
      variant: promoBadge.variant
    }, promoBadge.children));
  })), type === 'preview' && /*#__PURE__*/React.createElement(Reviews, {
    className: cx('reviews-with-padding'),
    reviews: device === null || device === void 0 ? void 0 : device.reviews
  })));
};